import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default from 'react';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import { Typography } from '../Typography/Typography.js';
import { Icon } from '../Icon/Icon.js';
import { classNames } from '../../helpers/classnames.js';

var InlineAlert = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'neutral' : _b, _c = _a.iconName, iconName = _c === void 0 ? Icons.WarningCircled : _c, children = _a.children, className = _a.className, props = __rest(_a, ["type", "iconName", "children", "className"]);
    return (React__default.createElement("div", __assign({ "data-testid": "InlineAlert", className: classNames('dsb_alert', "dsb_alert__".concat(type), className) }, props),
        React__default.createElement(Icon, { className: "dsb_alert-icon", iconName: iconName, size: "medium" }),
        typeof children === 'string' ? (React__default.createElement(Typography, { className: "dsb_alert-content", variant: "body3" }, children)) : (React__default.createElement("div", { className: "dsb_alert-custom-content" }, children))));
};

export { InlineAlert };
